module.exports = __webpack_public_path__ + "img/product_47.f84e35b.webp";